import styled from "styled-components";
import { Type } from "@ebscois/react-component-library";

export const StyledCitationTextType = styled.p`
  word-wrap: break-word;
  ${({ theme }) => `
    line-height: ${theme.line.height.base};
    margin-right: ${theme.space.xl};
    margin-left:  ${theme.space.xl};

    @media (max-width: ${theme.breakpoints.sm}) {
      font-size: ${theme.font.size.sm};
    }
  `}
`;

export const StyledCitationButtonContainer = styled.div`
  text-align: center;
  padding: ${({ theme }) => theme.space.md};
`;

export const StyledCitationTitleType = styled(Type)`
  ${({ theme }) => `
    margin-top: ${theme.space.md};
    margin-left: ${theme.space.md};
  `}
`;
